/**
 * global runtime constants for the plugin
 */
export var Const = {
    ////////////////////////// globals ////////////////////////////
    STORE_MODULE_NAME: "vue-provider-cache",
    REF: 'vpc',
    /**
     * router config for the remote
     * blockmaze-price-feed-microservice host
     */
    WS_PRICE_FEED_DOMAIN: {
        // HOST: 'https://pricefeed.finvasia.com',
        // HOST: 'https://awspricefeed.finvasia.com',
        ////HOST: 'https://209.59.129.124:5001',
        // HOST: 'https://209.59.129.124:5000',
        // HOST: 'https://69.167.152.107:5000',
        HOST: 'https://prism.shoonya.com:5000',
        EP_API_SEARCH_BY: '/api/ws-price-feed/search-by',
        EP_API_CONFIG: '/api/ws-price-feed/config'
    },
    ////////////////////////// actions ////////////////////////////
    // load global config 
    RUN_REGISTER_PROVIDERS: 'vue-provider-cache' + '/' + 'vpc' +
        '/RUN_REGISTER_PROVIDERS',
    // run heartbeat for s single cachetag 
    RUN_HERARTBEAT: 'vue-provider-cache' + '/' + 'vpc' +
        '/RUN_HERARTBEAT',
    //////////////////// mutations //////////////////////////////
    // start and register providers
    SET_REGISTER_PROVIDERS: 'vue-provider-cache' + '/' + 'vpc' +
        '/SET_REGISTER_PROVIDERS',
    // update heartbeat for single provider
    SET_HEARTBEAT: 'vue-provider-cache' + '/' + 'vpc' +
        '/SET_HEARTBEAT',
    //////////////////// getters //////////////////////////////
    // get heartbeats from all providers
    GET_HEARTBEATS: 'vue-provider-cache' + '/' + 'vpc' +
        '/GET_HEARTBEATS',
    // get all providers
    GET_PROVIDERS: 'vue-provider-cache' + '/' + 'vpc' +
        '/GET_PROVIDERS'
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/const.mod.ts
// module id = 3I5z
// module chunks = 75